module.exports = __webpack_public_path__ + "img/mem_coupon_font1_m.4bb1a99a.jpg";